/* eslint-disable no-confusing-arrow */
/* eslint-disable no-nested-ternary */

import styled, { css } from 'styled-components';
import { theme } from '../../theme';
import { Orientation, SeatMapVariant } from '../seatMapConstants';

export const setWidthAndHeight = (width, height) => `
  width: ${width ? `${width}px` : 'auto'};
  height: ${height ? `${height}px` : 'auto'};
`;

const seatSelectionColour = (isAvailable, isSelected) => {
  if (isSelected) {
    return css`
  fill: ${theme.colors.b20_light_green};
    `;
  }
  if (isAvailable) {
    return css`
      fill: ${theme.colors.w10_darkgreen};
    `;
  }
  return css`
    fill: ${theme.colors.silver};
  `;
};

export const SeatSchema = styled.div`
  ${({ width, height }) => setWidthAndHeight(width, height)}
  background: ${theme.colors.w40_silver};
  position: relative;
`;

export const SeatSchemaContainer = styled.div`
  width: ${({ width }) => width ? `${width}px` : 'auto'};
  border: 1px solid ${theme.colors.w10_darkgreen};
  border-radius: 4px;
  padding: 4px;
`;

export const Cell = styled.div`
  position: absolute;
  display: flex;
  top: ${({ top }) => top ? `${top}px` : '0'};
  left: ${({ left }) => left ? `${left}px` : '0'};
  ${({ width, height }) => setWidthAndHeight(width, height)}

  ${({ isOther }) => isOther && css`
    background: ${theme.colors.silver}; 
    border-radius: 4px;
    
    div, svg {
      background: ${theme.colors.silver};
    }
  `}
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  height: ${({ height }) => height ? `${height}px` : 'auto'};
  width: ${({ width, variant }) => variant === SeatMapVariant.VERTICAL ? '100%' : width ? `${width}px` : 'auto'};

  ${({ isSelected }) => isSelected && css`
    background: white; 
    box-shadow: 0px 0px 1px 1px ${theme.colors.brilliant_azure}; 
    border-radius: 4px;
  `}

  ${({ containExit }) => containExit && css`
    display: inline;
  `}

  &:hover {
    cursor: ${({ isAvailable }) => isAvailable ? 'pointer' : 'default'};
  }

  span {
    display: flex;
  }
`;

export const ExitWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;

  svg {
    &:last-child {
      transform: rotate(180deg);
    }
  }
`;

export const SeatId = styled.span`
  position: absolute;
  background: none;
  color: ${theme.colors.white};
  font-size: 9px;
  z-index: 1;
`;

export const WheelchairId = styled.span`
  position: absolute;
  background: none;
  color: ${({ isSelected }) => isSelected ? theme.colors.b20_brand_green : theme.colors.w10_darkgreen};
  font-weight: 700;
  font-size: 9px;
  z-index: 1;
  top: 5px;
  left: ${({ direction }) => direction === Orientation.RIGHT ? '17px' : '7px'};
`;

export const Other = styled.div`
  height: 32px;
  width: 100%;
  min-width: 32px;
`;

export const SeatMapIconWrapper = styled.div`
  display: flex;

  svg {
    transform: ${({ direction }) => direction === Orientation.LEFT ? 'rotate(180deg)' : 'none'};

    path, rect {
      ${({ isAvailable, isSelected }) => seatSelectionColour(isAvailable, isSelected)}
    }
  }
`;

export const WheelchairWrapper = styled.div`
  display: flex;

  svg {
    transform: ${({ direction }) => direction === Orientation.LEFT ? 'rotateY(180deg)' : 'none'};
    rect {
      fill: ${({ isSelected }) => isSelected ? theme.colors.white : 'none'};
    }
    path {
      ${({ isAvailable, isSelected }) => seatSelectionColour(isAvailable, isSelected)}
    }
  }
`;

export const Legend = styled.div`
  display: flex;
  align-items: center;

  font-weight: 300;

  ul {
    margin: 0;
    display: flex;
    list-style-type: none;
    padding: 0;
    gap: 8px;

    li {
      display: flex;
      align-items: center;
      color: ${theme.colors.darkgreen};
      svg {
        margin-right: 4px;
      }
    }
  }
`;
